module.exports = __webpack_public_path__ + "img/dsci0041.0c8a9a58.jpg";